export default "https://cdn-static.gokick.com/assets/3258f73df43fa954b49bc6bd6de466cccdb5fe2c/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";